import type { UserProfileData } from '../UserApi'
import type { UserModel } from '../../interfaces/UserModel'

export const USER_UPDATED_EVENT = 'forpy:user-updated'

export function dispatchUserUpdated (): void {
  window.dispatchEvent(new CustomEvent(USER_UPDATED_EVENT))
}

export function getStoredUser (): UserModel | null {
  const storedUser = window.localStorage.getItem('user')
  if (!storedUser) return null

  try {
    return JSON.parse(storedUser) as UserModel
  } catch {
    return null
  }
}

export function getClientManagementPath (): string {
  return getStoredUser()?.usage_profile === 'own_company'
    ? '/minha-empresa'
    : '/clientes'
}

export function updateStoredUser (updatedProfile: UserProfileData): void {
  const storedUser = window.localStorage.getItem('user')

  if (!storedUser) return

  const parsedUser: UserModel = JSON.parse(storedUser)
  window.localStorage.setItem('user', JSON.stringify({
    ...parsedUser,
    ...updatedProfile,
    id_user: parsedUser.id_user || updatedProfile.rowid || updatedProfile.id || ''
  }))
  dispatchUserUpdated()
}
